// extracted by mini-css-extract-plugin
module.exports = {"root":"styles_root__dPtSG","col":"styles_col__3V0Zx","actions":"styles_actions__2DyHl","conflict":"styles_conflict__3xNat"};